import { RegistrationState, REGISTRATION_FEATURE_KEY } from "./registration.slice";
import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../index";

const getRegistrationState = (rootState: StoreState): RegistrationState => rootState[REGISTRATION_FEATURE_KEY];

const getToken = createSelector(getRegistrationState, (state: RegistrationState) => state.token);

const getLoading = createSelector(getRegistrationState, (state: RegistrationState) => state.loading);

const getError = createSelector(getRegistrationState, (state: RegistrationState) => state.error);

const getUserCreated = createSelector(getRegistrationState, (state: RegistrationState) => state.userCreated);

const getUserCreationLoading = createSelector(getRegistrationState, (state: RegistrationState) => state.userCreationLoading);

const getUserCreationError = createSelector(getRegistrationState, (state: RegistrationState) => state.userCreationError);

export const registrationSelectors = {
  getRegistrationState,
  getToken,
  getLoading,
  getError,
  getUserCreated,
  getUserCreationLoading,
  getUserCreationError,
};